module.exports = function() {
    $('.next-section').on('click', function(e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: $(this).parent().next().offset().top - $('.header').outerHeight()
        }, 750);
    });
};